<template>
  <div>
    <!-- alerta -->
    <Alert
      :alert="alert"
      :type="alertType"
      :title="alertTitle"
      :message="alertMessage"
    />

    <template v-if="skeletonLoader">
      <v-skeleton-loader
        type="table-heading, table-thead, table-tbody@2, table-tfoot"
      >
      </v-skeleton-loader>
    </template>
    <template v-else>
      <!-- tabla -->
      <v-card>
        <v-card-title class="text-h6 text-md-h5 font-weight-bold primary--text">
          <v-row>
            <v-col 
              cols="12"
              sm="7"
            >
              <v-tooltip top>
                <template v-slot:activator="{ on, attrs }">
                  <v-btn
                    fab
                    small
                    exact
                    color="primary"
                    class="mr-4"
                    v-bind="attrs" 
                    v-on="on" 
                    @click="regresar"
                  >
                    <v-icon>
                      mdi-arrow-left
                    </v-icon>
                  </v-btn>
                </template>
                <span>Regresar</span>
              </v-tooltip>

              Gestionar Lideres
            </v-col>
            
            <v-col 
              cols="12"
              sm="5"
            >
              <div class="d-flex align-center">
                <v-text-field
                  outlined
                  dense
                  hide-details
                  append-icon="mdi-magnify"
                  class="mr-4"
                  label="Buscar Lider"
                  v-model="searchTable"
                >
                </v-text-field>

                <v-btn
                  exact
                  color="primary"
                  class="mr-4"
                  @click="openImportar"
                >
                  Importar
                </v-btn>

                <v-btn
                  exact
                  color="primary"
                  @click="open"
                >
                  Registrar
                </v-btn>
              </div>
            </v-col>
          </v-row>
        </v-card-title>

        <v-data-table
          fixed-header
          height="calc(100vh - 220px)"
          class="elevation-2"
          :loading="skeletonLoader"
          :headers="headersTable"
          :items="lideres"
          :search="searchTable"
          :footer-props="{ 'items-per-page-options': [50, 100, -1] }"
        >        
          <template v-slot:[`item.acciones`]="{ item }">
            <v-tooltip top>
              <template v-slot:activator="{ on, attrs }">
                <v-icon
                  color="primary"
                  class="mr-2"
                  v-bind="attrs" 
                  v-on="on"
                  @click="detalles(item.id)"
                  >
                  mdi-eye
                </v-icon>
              </template>
              <span>Detalles</span>
            </v-tooltip>

            <v-tooltip top>
              <template v-slot:activator="{ on, attrs }">
                <v-icon
                  color="primary"
                  class="mr-2"
                  v-bind="attrs" 
                  v-on="on"
                  @click="editar(item.id)"
                  >
                  mdi-pencil
                </v-icon>
              </template>
              <span>Actualizar</span>
            </v-tooltip>

            <v-tooltip top>
              <template v-slot:activator="{ on, attrs }">
                <v-icon
                  color="error"
                  v-bind="attrs" 
                  v-on="on"
                  @click="alertaEliminar(item.id)"
                >
                  mdi-delete
                </v-icon>
              </template>
              <span>Eliminar</span>
            </v-tooltip>
          </template>

          <template v-slot:top>
            <!-- formulario registro -->
            <v-dialog 
              persistent
              scrollable
              max-width="520px"
              v-model="dialogForm" 
            >
              <v-card :loading="loadingForm">
                <v-card-title class="justify-center">
                  <p class="text-h5 font-weight-bold primary--text">{{ formTitle }}</p>
                </v-card-title>
                <v-card-text>
                  <v-container>
                    <v-row justify="center">
                      <v-col 
                        cols="12"
                        md="10"
                      >
                        <v-form 
                          ref="form" 
                          v-model="form"
                        >
                          <v-text-field
                            outlined
                            dense
                            disabled
                            type="text"
                            label="Competencia"
                            v-model="competenciaSeleccionada"
                          >
                          </v-text-field>

                          <v-select
                            outlined
                            dense
                            label="Categoria*"
                            :items="categoriasCompetencia"
                            item-value="categoria_id"
                            item-text="categoria"
                            v-model="categoria"
                            :rules="categoriaReglas"
                          >
                          </v-select>

                          <v-select
                            outlined
                            dense
                            label="Tipo de Lider*"
                            :items="tiposLider"
                            item-value="id"
                            item-text="tipo_lider"
                            v-model="tipoLider"
                            :rules="tipoLiderReglas"
                          >
                          </v-select>
            
                          <v-select
                            outlined
                            dense
                            label="Regional*"
                            :items="regionales"
                            item-value="id"
                            item-text="regional"
                            v-model="regional"
                            :rules="regionalReglas"
                          >
                          </v-select>

                          <v-select
                            outlined
                            dense
                            label="Centro de Formación*"
                            :items="centrosFormacion"
                            item-value="id"
                            item-text="centro_formacion"
                            v-model="centroFormacion"
                            :rules="centroFormacionReglas"
                          >
                          </v-select>

                          <v-select
                            outlined
                            dense
                            label="Tipo de Identificación*"
                            :items="tiposIdentificacion"
                            item-value="id"
                            item-text="tipo_identificacion"
                            v-model="tipoIdentificacion"
                            :rules="tipoIdentificacionReglas"
                          >
                          </v-select>

                          <v-text-field
                            outlined
                            dense
                            type="number"
                            label="Número de Identificación*"
                            v-model="identificacion"
                            :rules="identificacionReglas"
                          >
                          </v-text-field>

                          <v-text-field
                            outlined
                            dense
                            type="text"
                            label="Nombres*"
                            maxlength="100"
                            counter
                            v-model.trim="nombres"
                            :rules="nombresReglas"
                          >
                          </v-text-field>

                          <v-text-field
                            outlined
                            dense
                            type="text"
                            label="Apellidos*"
                            maxlength="100"
                            counter
                            v-model.trim="apellidos"
                            :rules="apellidosReglas"
                          >
                          </v-text-field>

                          <v-text-field
                            outlined
                            dense
                            type="text"
                            label="Correo Electronico*"
                            maxlength="100"
                            counter
                            v-model.trim="correo"
                            :rules="correoReglas"
                          >
                          </v-text-field>

                          <v-text-field
                            outlined
                            dense
                            type="number"
                            label="Telefono Movil*"
                            maxlength="10"
                            counter
                            v-model="telefonoMovil"
                            :rules="telefonoMovilReglas"
                          >
                          </v-text-field>

                          <v-text-field
                            outlined
                            dense
                            type="text"
                            label="Direccion*"
                            maxlength="100"
                            counter
                            v-model.trim="direccion"
                            :rules="direccionReglas"
                          >
                          </v-text-field>

                          <v-dialog 
                            ref="fechaNacimiento" 
                            persistent
                            width="300px"
                            v-model="dialogFechaNacimiento" 
                            :return-value.sync="fechaNacimiento"
                          >
                            <template v-slot:activator="{ on, attrs }">
                              <v-text-field 
                                outlined 
                                dense 
                                readonly
                                prepend-inner-icon="mdi-calendar" 
                                label="Fecha de Nacimiento*" 
                                v-model="fechaNacimiento" 
                                :rules="fechaNacimientoReglas" 
                                v-bind="attrs" 
                                v-on="on"
                              >
                              </v-text-field>
                            </template>

                            <v-date-picker 
                              scrollable 
                              color="primary"
                              v-model="fechaNacimiento"
                            >
                              <v-spacer></v-spacer>
                              <v-btn 
                                text 
                                color="error" 
                                @click="dialogFechaNacimiento = false"
                              >
                                Cancelar
                              </v-btn>
                              <v-btn 
                                text 
                                color="primary" 
                                @click="$refs.fechaNacimiento.save(fechaNacimiento)"
                              >
                                OK
                              </v-btn>
                            </v-date-picker>
                          </v-dialog>

                          <v-select
                            outlined
                            dense
                            label="Genero*"
                            :items="generos"
                            item-value="id"
                            item-text="genero"
                            v-model="genero"
                            :rules="generoReglas"
                          >
                          </v-select>

                          <v-select
                            outlined
                            dense
                            label="Estado Civil*"
                            :items="estadosCiviles"
                            item-value="id"
                            item-text="estado_civil"
                            v-model="estadoCivil"
                            :rules="estadoCivilReglas"
                          >
                          </v-select>

                          <v-select
                            outlined
                            dense
                            label="Estrato*"
                            :items="estratos"
                            item-value="id"
                            item-text="estrato"
                            v-model="estrato"
                            :rules="estratoReglas"
                          >
                          </v-select>

                          <v-select
                            outlined
                            dense
                            label="Zona*"
                            :items="zonas"
                            item-value="id"
                            item-text="zona"
                            v-model="zona"
                            :rules="zonaReglas"
                          >
                          </v-select>

                          <v-select
                            outlined
                            dense
                            label="Discapacidad*"
                            :items="discapacidades"
                            item-value="id"
                            item-text="discapacidad"
                            v-model="discapacidad"
                            :rules="discapacidadReglas"
                          >
                          </v-select>

                          <v-select
                            outlined
                            dense
                            label="Talla de Camiseta*"
                            :items="tallas"
                            v-model="talla"
                            :rules="tallaReglas"
                          >
                          </v-select>
                        </v-form>
                      </v-col>
                    </v-row>
                  </v-container>
                </v-card-text>

                <v-card-actions>
                  <v-spacer></v-spacer>
                  <v-btn 
                    text 
                    color="error" 
                    @click="close"
                  >
                    Cancelar
                  </v-btn>

                  <template v-if="editedIndex === -1">
                    <v-btn 
                      text 
                      exact 
                      color="primary" 
                      @click="registrar"
                    >
                      Registrar
                    </v-btn>
                  </template>

                  <template v-else>
                    <v-btn 
                      text 
                      exact 
                      color="primary" 
                      @click="actualizar"
                    >
                      Actualizar
                    </v-btn>
                  </template>
                </v-card-actions>
              </v-card>
            </v-dialog>

            <!-- formulario importacion -->
            <v-dialog 
              persistent
              max-width="500px"
              v-model="dialogFormImportar" 
            >
              <v-card :loading="loadingFormImportar">
                <v-card-title class="justify-center">
                  <p class="text-h5 font-weight-bold primary--text">Importar Lideres Centro de Formación</p>
                </v-card-title>
                <v-card-text>
                  <v-container>
                    <v-row justify="center">
                      <v-col 
                        cols="12"
                        md="10"
                      >
                        <v-form 
                          ref="formImportar" 
                          v-model="formImportar"
                        >
                          <v-row>
                            <v-col cols="11">
                              <v-file-input 
                                outlined 
                                dense 
                                prepend-icon="" 
                                append-icon="mdi-paperclip" 
                                label="Importar archivo excel" 
                                accept=".xlsx"
                                truncate-length="100" 
                                counter 
                                show-size 
                                v-model="archivoLideres"
                                :rules="archivoLideresReglas"
                              >
                              </v-file-input>
                            </v-col>

                            <v-col cols="1">
                              <v-tooltip top>
                                <template v-slot:activator="{ on, attrs }">
                                  <v-icon
                                    medium
                                    color="primary"
                                    class="mt-2"
                                    v-bind="attrs"
                                    v-on="on"
                                    @click="descargarPlantilla()"
                                  >
                                    mdi-cloud-download
                                  </v-icon>
                                </template>
                                <span>Descargar Plantilla</span>
                              </v-tooltip>
                            </v-col>
                          </v-row>
                        </v-form>
                      </v-col>
                    </v-row>
                  </v-container>
                </v-card-text>

                <v-card-actions>
                  <v-spacer></v-spacer>
                  <v-btn 
                    text 
                    color="error" 
                    @click="closeImportar"
                  >
                    Cancelar
                  </v-btn>

                  <v-btn 
                    text 
                    exact
                    color="primary" 
                    @click="importar"
                  > 
                    Importar 
                  </v-btn>
                </v-card-actions>
              </v-card>
            </v-dialog>

            <!-- alerta confirmacion eliminar -->
            <v-dialog 
              v-model="dialogDelete" 
              max-width="400px"
            >
              <v-card>
                <v-card-title class="text-h6 text-md-h5 justify-center">
                  ¿Desea eliminar el lider?
                </v-card-title>
                <v-card-actions>
                  <v-spacer></v-spacer>
                  <v-btn 
                    text 
                    color="primary" 
                    @click="closeDelete"
                  >
                    Cancelar
                  </v-btn>
                  <v-btn 
                    text 
                    color="error" 
                    @click="eliminar(idLider)"
                  >
                    OK
                  </v-btn>
                  <v-spacer></v-spacer>
                </v-card-actions>
              </v-card>
            </v-dialog>
          </template>
        </v-data-table>
      </v-card>      
    </template>
  </div>
</template>

<script>
import Alert from '../../../components/admin/Alert.vue';

export default {
  data: () => ({
    skeletonLoader: true,
    searchTable: null,

    alert: false,
    alertType: '',
    alertTitle: '',
    alertMessage: '',

    headersTable: [
      {
        text: "Identificación",
        value: "identificacion",
        align: "start",
        width: "10%",
        sortable: false,
        class: ["text-subtitle-1", "font-weight-black"],
      },

      {
        text: "Nombres",
        value: "nombres",
        align: "start",
        width: "15%",
        class: ["text-subtitle-1", "font-weight-black"],
      },

      {
        text: "Apellidos",
        value: "apellidos",
        align: "start",
        width: "15%",
        class: ["text-subtitle-1", "font-weight-black"],
      },

      {
        text: "Tipo de Lider",
        value: "tipo_lider",
        align: "start",
        width: "15%",
        class: ["text-subtitle-1", "font-weight-black"],
      },

      {
        text: "Centro de Formación",
        value: "centro_formacion",
        align: "start",
        width: "30%",
        class: ["text-subtitle-1", "font-weight-black"],
      },

      {
        text: "Acciones",
        value: "acciones",
        align: "center",
        sortable: false,
        filterable: false,
        class: ["text-subtitle-1", "font-weight-black"],
      },
    ],

    form: true,
    loadingForm: false,
    dialogForm: false,

    formImportar: true,
    loadingFormImportar: false,
    dialogFormImportar: false,

    dialogDelete: false,

    competenciaSeleccionada: '',

    categoria: null,
    categoriaReglas: [
      (v) => !!v || "Seleccione una categoria"
    ],

    tipoLider: null,
    tipoLiderReglas: [
      (v) => !!v || "Seleccione un tipo de lider"
    ],

    regional: null,
    regionalReglas: [
      (v) => !!v || "Seleccione una regional"
    ],

    centroFormacion: null,
    centroFormacionReglas: [
      (v) => !!v || "Seleccione un centro de formación"
    ],

    tipoIdentificacion: null,
    tipoIdentificacionReglas: [
      (v) => !!v || "Seleccione un tipo de identificación",
    ],

    tiposIdentificacion: [
      { tipo_identificacion: "Cedula de Ciudadania", id: 2 },
      { tipo_identificacion: "Documento Extranjero", id: 3 }
    ],

    identificacion: '',
    identificacionReglas: [
      (v) => !!v || "Escriba un número de identificación",
      (v) => (!v || v > 0) || "El número debe ser mayor a 0",
      (v) => (v && v.length >= 6) || "Minimo 6 digitos",
      (v) => (v && v.length <= 10) || "Maximo 10 digitos",
    ],

    nombres: '',
    nombresReglas: [(v) => !!v || "Escriba los nombres"],

    apellidos: '',
    apellidosReglas: [(v) => !!v || "Escriba los apellidos"],

    correo: '',
    correoReglas: [
      (v) => !!v || "Escriba un correo electrónico",
      (v) => /.+@.+\..+/.test(v) || "Correo electrónico no válido",
    ],

    telefonoMovil: '',
    telefonoMovilReglas: [
      (v) => !!v || "Escriba un número de telefono movil",
      (v) => (!v || v > 0) || "El número debe ser mayor a 0",
      (v) => (v && v.length <= 10) || "Maximo 10 digitos"
    ],

    direccion: '',
    direccionReglas: [(v) => !!v || "Escriba una dirección"],

    dialogFechaNacimiento: false,
    fechaNacimiento: null,
    fechaNacimientoReglas: [(v) => !!v || "Seleccione una fecha"],

    genero: null,
    generoReglas: [
      (v) => (!!v) || "Seleccione un genero",
    ],

    generos: [
      { genero: "Femenino", id: 1 },
      { genero: "Masculino", id: 2 },
    ],

    estadoCivil: null,
    estadoCivilReglas: [(v) => !!v || "Seleccione un estado civil"],

    estadosCiviles: [
      { estado_civil: "Viudo", id: 1 },
      { estado_civil: "Separado", id: 2 },
      { estado_civil: "Unión Libre", id: 3 },
      { estado_civil: "Casado", id: 4 },
      { estado_civil: "Soltero", id: 5 },
      { estado_civil: "Indiferente", id: 6 }
    ],

    estrato: null,
    estratoReglas: [(v) => !!v || "Seleccione un estrato"],

    estratos: [
      { estrato: 1, id: 1 },
      { estrato: 2, id: 2 },
      { estrato: 3, id: 3 },
      { estrato: 4, id: 4 },
      { estrato: 5, id: 5 },
      { estrato: 6, id: 6 },
    ],

    zona: null,
    zonaReglas: [(v) => !!v || "Seleccione una zona"],

    zonas: [
      { zona: "Urbana", id: 1 },
      { zona: "Rural", id: 2 },
    ],

    discapacidad: null,
    discapacidadReglas: [(v) => !!v || "Seleccione una discapacidad"],

    discapacidades: [
      { discapacidad: "Ninguna", id: 1 },
      { discapacidad: "Cognitiva", id: 2 },
      { discapacidad: "Fisica", id: 3 },
    ],

    talla: null,
    tallaReglas: [
      (v) => !!v || "Seleccione una talla"
    ],

    tallas: ["XS", "S", "M", "L", "XL", "XXL"],

    archivoLideres: null,
    archivoLideresReglas: [
      (v) => !!v || "Seleccione un archivo excel"
    ],

    idPersona: null,

    idLider: null,

    editedIndex: -1,
  }),

  components: {
    Alert
  },

  mounted() {
    this.$store.dispatch("gestionarLideres", this.$route.params.id_competencia);

    this.$store.dispatch("crearRegionales");
    this.$store.dispatch("crearCentrosFormacion");
    this.$store.dispatch("crearTiposLider");
    this.$store.dispatch("detallesCompetencia", this.$route.params.id_competencia);
    this.$store.dispatch("gestionarCategoriasCompetencia", this.$route.params.id_competencia);

    setTimeout(() => {
      this.skeletonLoader = false;
    }, 1000);
  },

  computed: {
    formTitle() {
      return this.editedIndex === -1 ? 'Registrar Lider' : 'Actualizar Lider'
    },

    lideres() {
      return this.$store.getters.obtenerLideres;
    },

    competencia() {
      return this.$store.getters.obtenerCompetencia;
    },

    categoriasCompetencia() {
      return this.$store.getters.obtenerCategoriasCompetencia;
    },

    tiposLider() {
      return this.$store.getters.obtenerTiposLiderCompetencia(3);
    },

    regionales() {
      return this.$store.getters.obtenerRegionales;
    },

    centrosFormacion() {
      return this.$store.getters.obtenerCentrosFormacion(this.regional);
    }
  },

  watch: {
    dialogForm(val) {
      val || this.close()
    },

    dialogFormImportar(val) {
      val || this.closeImportar()
    },

    dialogDelete(val) {
      val || this.closeDelete()
    }
  },

  methods: {
    open() {
      this.dialogForm = true
      this.competenciaSeleccionada = this.competencia.competencia
    },

    openImportar() {
      this.dialogFormImportar = true
    },

    close() {
      this.$refs.form.reset();
      this.dialogForm = false
      this.editedIndex = -1
    },

    closeImportar() {
      this.$refs.formImportar.reset();
      this.dialogFormImportar = false 
      this.editedIndex = -1
    },

    registrar() {
      if (this.$refs.form.validate()) {
        const nombresPersona = this.nombres.split(" ")
        const apellidosPersona = this.apellidos.split(" ")

        const lider = {
          competencia_id:         this.$route.params.id_competencia,
          categoria_id:           this.categoria,
          tipo_lider_id:          this.tipoLider,
          centro_formacion_id:    this.centroFormacion,
          tipo_identificacion_id: this.tipoIdentificacion,
          identificacion:         this.identificacion,
          primer_nombre:          nombresPersona[0],
          segundo_nombre:         nombresPersona[1],
          primer_apellido:        apellidosPersona[0],
          segundo_apellido:       apellidosPersona[1],
          correo:                 this.correo,
          telefono_movil:         this.telefonoMovil,
          direccion:              this.direccion,
          fecha_nacimiento:       this.fechaNacimiento,
          genero_id:              this.genero,
          estado_civil_id:        this.estadoCivil,
          estrato:                this.estrato,
          zona_id:                this.zona,
          discapacidad_id:        this.discapacidad,
          talla_camiseta:         this.talla
        }

        this.loadingForm = true;

        this.$store.dispatch("registrarLider", lider)
        .then((response) => {
          if (response.status == "success") {
            this.loadingForm  = false;
            this.close();
            let message = response.message.split(',')
            
            this.alertType    = "success--text";
            this.alertTitle   = message[0];
            this.alertMessage = message[1];
            this.alert        = true;
            
            this.skeletonLoader = true;
            
            this.$store.dispatch("gestionarLideres", this.$route.params.id_competencia);
            setTimeout(() => {
              this.alert = false;
              this.skeletonLoader = false;
            }, 1000);
          } 
          else {
            this.loadingForm  = false
            this.alertType    = "error--text";
            this.alertTitle   = "Error";

            for (const error in response.message) {
              this.alertMessage = response.message[error][0]
            }

            this.alert = true;

            setTimeout(() => {
              this.alert = false
            }, 3000)
          }
        })
        .catch(() => {});
      }     
    },

    importar() {
      if (this.$refs.formImportar.validate()) {
        this.loadingFormImportar = true;
        
        const lideres = new FormData();
        lideres.set("competencia", this.$route.params.id_competencia);
        lideres.set("archivoLider", this.archivoLideres);

        this.$store.dispatch("importarLideres", lideres)
        .then((response) => {
          if (response.status == "success") {
            this.loadingFormImportar = false
            this.closeImportar();

            let message = response.message.split(',')

            this.alertType    = "success--text";
            this.alertTitle   = message[0];
            this.alertMessage = message[1];
            this.alert        = true;

            this.skeletonLoader = true

            this.$store.dispatch("gestionarLideres", this.$route.params.id_competencia)
            setTimeout(() => {
              this.alert = false;
              this.skeletonLoader = false;
            }, 1000);
          }
          else {
            this.loadingFormImportar  = false
            this.alertType    = "error--text";
            this.alertTitle   = "Error";

            for (const error in response.message) {
              this.alertMessage = response.message[error][0]
            }

            this.alert = true;

            setTimeout(() => {
              this.alert = false
            }, 3000)
          }  
        })
        .catch(() => {})
      }
    },

    descargarPlantilla() {
      this.$store.dispatch("descargarPlantillaLideres")
      .then((response) => {
        const urlReporte = window.URL.createObjectURL(new Blob([response.data]))
        const link = document.createElement('a')
        link.href= urlReporte
        link.setAttribute('download', 'Plantilla-Lideres-Centro-Formación.xlsx')
        document.body.appendChild(link)
        link.click();
      })
    },

    detalles(id) {
      this.$router.push({
        name: "lider-detalle",
        params: { id_lider: id }
      });
    },

    editar(id) {
      this.editedIndex = 1;

      this.$store.dispatch("detallesLider", id)

      setTimeout(() => {
        const lider = this.$store.getters.obtenerLider

        this.idLider = id
        this.competenciaSeleccionada = lider.competencia
        this.categoria          = lider.categoria_id
        this.tipoLider          = lider.tipo_lider_id
        this.regional           = lider.regional_id
        this.centroFormacion    = lider.centro_formacion_id
        this.idPersona          = lider.persona_id
        this.tipoIdentificacion = lider.tipo_identificacion_id
        this.identificacion     = lider.identificacion
        this.nombres            = lider.nombres
        this.apellidos          = lider.apellidos
        this.telefonoMovil      = lider.telefono_movil
        this.correo             = lider.correo
        this.direccion          = lider.direccion
        this.fechaNacimiento    = lider.fecha_nacimiento
        this.genero             = lider.genero_id
        this.estadoCivil        = lider.estado_civil_id
        this.estrato            = lider.estrato
        this.zona               = lider.zona_id
        this.discapacidad       = lider.discapacidad_id
        this.talla              = lider.talla_camiseta
      }, 1000);

      this.dialogForm = true
    },

    actualizar() {
      if (this.$refs.form.validate()) {
        const nombresPersona = this.nombres.split(" ")
        const apellidosPersona = this.apellidos.split(" ")

        const lider = {
          id:                     this.idLider,
          competencia_id:         this.$route.params.id_competencia,
          categoria_id:           this.categoria,
          tipo_lider_id:          this.tipoLider,
          centro_formacion_id:    this.centroFormacion,
          persona_id:             this.idPersona,
          tipo_identificacion_id: this.tipoIdentificacion,
          identificacion:         this.identificacion,
          primer_nombre:          nombresPersona[0],
          segundo_nombre:         nombresPersona[1],
          primer_apellido:        apellidosPersona[0],
          segundo_apellido:       apellidosPersona[1],
          correo:                 this.correo,
          telefono_movil:         this.telefonoMovil,
          direccion:              this.direccion,
          fecha_nacimiento:       this.fechaNacimiento,
          genero_id:              this.genero,
          estado_civil_id:        this.estadoCivil,
          estrato:                this.estrato,
          zona_id:                this.zona,
          discapacidad_id:        this.discapacidad,
          talla_camiseta:         this.talla
        };

        this.loadingForm = true

        this.$store.dispatch("actualizarLider", lider)
        .then((response) => {
          if (response.status == "success") {
            this.loadingForm = false;
            this.close();

            let message       = response.message.split(',')
            this.alertType    = "success--text";
            this.alertTitle   = message[0];
            this.alertMessage = message[1];
            this.alert        = true;

            this.skeletonLoader = true;

            this.$store.dispatch("gestionarLideres", this.$route.params.id_competencia)
            setTimeout(() => {
              this.alert = false;
              this.skeletonLoader = false
            }, 1000)
          } 
          else {
            this.loadingForm  = false
            this.alertType    = "error--text";
            this.alertTitle   = "Error";

            for (const error in response.message) {
              this.alertMessage = response.message[error][0]
            }

            this.alert = true;

            setTimeout(() => {
              this.alert = false
            }, 3000)
          }
        })
        .catch(() => {});
      }
    },

    closeDelete() {
      this.dialogDelete = false;
      this.editedIndex = -1;
    },

    alertaEliminar(id) {
      this.idLider = id
      this.dialogDelete = true
    },

    eliminar() {     
      this.dialogDelete = false

      this.$store.dispatch("eliminarLider", this.idLider)
      .then((response) => {
        if (response.status == "success") {
          let message = response.message.split(',')

          this.alertType    = "success--text";
          this.alertTitle   = message[0];
          this.alertMessage = message[1];
          this.alert        = true;
         
          this.skeletonLoader = true;

          this.$store.dispatch("gestionarLideres", this.$route.params.id_competencia);
          setTimeout(() => {
            this.alert = false;
            this.skeletonLoader = false;
          }, 1000);
        }
        else {
          this.alertType    = "error--text";
          this.alertTitle   = "Error";

          for (const error in response.message) {
            this.alertMessage = response.message[error][0]
          }

          this.alert = true;

          setTimeout(() => {
            this.alert = false
          }, 3000)
        }
      })
      .catch(() => {});
    },

    regresar() {
      this.$router.back()
    }
  },
};
</script>